module.exports = __webpack_public_path__ + "img/laptop-done.539e1372.svg";